(() => {
  const links = document.querySelectorAll('[data-jump-link]');
  const componentsPosition = [];
  const BreakException = {};

  progressBar()

  document.querySelectorAll('.jump_links_block__item_link').forEach(element => {
    const targetId = new URL(element.href).hash?.replace('#', '');
    const targetComponent = document.getElementById(targetId);
    if (targetComponent) {
      componentsPosition.push(targetComponent);
    } else {
      componentsPosition.push(-1);
    }
  });

  window.addEventListener('resize', () => {
    progressBar();
  });

  window.addEventListener('scroll', () => {
    progressBar();

    const position = window.scrollY || document.body.scrollTop;

    try {
      let index = componentsPosition.length;

      while (--index && position + 96 < componentsPosition[index].getBoundingClientRect().top + position) { }

      links.forEach((link) => link.classList.remove('active-link'));
      if (index >= 0) {
        links[index].classList.add('active-link');
      }

    } catch (e) {
      if (e !== BreakException) throw e;
    }

  }, { passive: true });

  function progressBar () {
    const jumpLinks = document.querySelector(".jump_links_block__wrapper");
    const firstComponent = jumpLinks.nextElementSibling;
    const lastComponent = jumpLinks.parentElement.lastElementChild;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight || window.innerHeight;

    var scrolled = 0;

    if (scrollTop > firstComponent.offsetTop && scrollTop < lastComponent.offsetTop + lastComponent.offsetHeight - clientHeight) {
      scrolled = (scrollTop - firstComponent.offsetTop) / (lastComponent.offsetTop + lastComponent.offsetHeight - firstComponent.offsetTop - clientHeight) * 100;
    }
    else if (scrollTop >= lastComponent.offsetTop + lastComponent.offsetHeight - clientHeight) {
      scrolled = 100;
    }
    const progressBar = document.querySelector('.progress_bar .progress_bar__progress');
    progressBar.style.width = `${scrolled}%`;
  };
})();
